import React, { useEffect } from "react";

import GreyTable from "../../components/Tables/GreyTable";
import { useDispatch, useSelector } from "react-redux";
import Cookies from 'js-cookie';
import { OverallDashBoard } from "../../Redux/Slice/Grey/GreyDashboard/GreyDashboardSlice";
import { useTheme } from "../../Themecontext/Themecontext";
import { Loader } from "../../components/Loader/Loader";

export default function OberallDashBoard() {
    const token = Cookies.get("authToken");
    const dispatch = useDispatch();
    const FinancialYear = Cookies.get("FinancialYear");

    // const isdark = Cookies.get("theme") || "light";
    const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
    const { OverallDashBoardata, greyDashboardLoading } = useSelector((state) => state.GreyDashboardSlice);

    const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
    const iscolourDark = Colourdata?.data?.find(
        (el) => el.ExeName === "GRAYDARKNEW",
    );

    const { theme } = useTheme();
    const isdark = theme;


    const selectedYear = DataMain?.AC_Year_List?.find(
        (item) => String(item.AcYearID) === String(FinancialYear)
    );

    const formatDate = (date) => {
        if (!date) return "";

        const [day, month, year] = date.trim().split("/");

        return `${year}-${month}-${day}`;
    };

    // AcYear = "01/04/2025 - 31/03/2026"
    const [start, end] = selectedYear?.AcYear?.split(" - ") || [];

    const StartDate = formatDate(start);
    const EndDate = formatDate(end);


    useEffect(() => {
        dispatch(OverallDashBoard({
            StartDate,
            EndDate,
            token
        }))
    }, [StartDate, EndDate, dispatch, token])



    const tableData = (OverallDashBoardata?.Data || []).map(
        (row, index, arr) => ({
            srNumber: (index + 1),
            Type: row.Type,
            Apr: row.Apr,
            Aug: row.Aug,
            Dec: row.Dec,
            Feb: row.Feb,
            Jan: row.Jan,
            Jul: row.Jul,
            Jun: row.Jun,
            Mar: row.Mar,
            May: row.May,
            Nov: row.Nov,
            Oct: row.Oct,
            Sep: row.Sep,
            Total: row.Total,
        })
    );

    const columns = [
        {
            label: "Sr No.",
            key: "srNumber",
            align: "center",
            colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
        },
        {
            label: "Type",
            key: "Type",
            align: "left",
            colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2,
        },
        {
            label: "Total",
            key: "Total",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Apr",
            key: "Apr",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "May",
            key: "May",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Jun",
            key: "Jun",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Jul",
            key: "Jul",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Aug",
            key: "Aug",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Sep",
            key: "Sep",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Oct",
            key: "Oct",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Nov",
            key: "Nov",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Dec",
            key: "Dec",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Jan",
            key: "Jan",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Feb",
            key: "Feb",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
        {
            label: "Mar",
            key: "Mar",
            align: "right",
            format: true,
            colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5,
        },
    ];

    if (greyDashboardLoading) {
        return (
            <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Loader />
            </div>
        );
    }

    return (
        <>
            <div className="pageContainer">

                <div
                    style={{
                        borderTopLeftRadius: "12px",
                        borderTopRightRadius: "12px",
                        overflow: "hidden",
                        margin: 0,
                        boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                    }}
                >
                    <div
                        style={{
                            backgroundColor:
                                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
                            color:
                                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8,
                            borderTopLeftRadius: "12px",
                            borderTopRightRadius: "12px",
                            padding: "14px",
                        }}
                    >
                        <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px", fontWeight: "700" }}>
                            OVERALL DASHBOARD
                        </h2>
                    </div>

                    <div style={{ backgroundColor: "#fff" }}>
                        <GreyTable columns={columns} data={tableData} iscolourDark={iscolourDark}
                            iscolour={iscolour} />

                    </div>
                </div>
            </div>




        </>
    );
}
